import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'objectKeyValue'
})
export class ObjectKeyValuePipe implements PipeTransform {

  transform(object: {}, ...args: unknown[]): unknown {
    const key = Object.keys(object)[0];
    return object[key];
  }

}
